import { render, staticRenderFns } from "./PromoHistory.vue?vue&type=template&id=4b89a3db"
import script from "./PromoHistory.vue?vue&type=script&lang=js"
export * from "./PromoHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports